import { Posthog } from '@capawesome/capacitor-posthog';

const initPosthog = () => Posthog.setup({
  apiKey: "phc_tD3ACzk70xrQh2tQ0hCeYuJdYckwzyvqFUu7ASNYEBU",
  host: 'https://us.i.posthog.com',
});

export { initPosthog, Posthog };